import api from './api';

const despesaService = {
  listarPorMesAno: async (ano, mes) => {
    const response = await api.get('/despesas', { params: { ano, mes } });
    return response.data;
  },

  listarPorAno: async (ano) => {
    const response = await api.get('/despesas/relatorio-anual', { params: { ano } });
    return response.data;
  },

  criarDespesa: async (dados) => {
    const response = await api.post('/despesas', dados);
    return response.data;
  },

  atualizarDespesa: async (id, dados) => {
    const response = await api.put(`/despesas/${id}`, dados);
    return response.data;
  },

  marcarComoPago: async (id) => {
    const response = await api.patch(`/despesas/${id}/pagar`);
    return response.data;
  },

  marcarComoPagoEmMassa: async (ids) => {
    const response = await api.patch('/despesas/baixa-em-massa', ids);
    return response.data;
  },

  deletarDespesa: async (id) => {
    await api.delete(`/despesas/${id}`);
  },

  replicarDespesas: async (mesOrigem, anoOrigem) => {
    const response = await api.post('/despesas/replicar', { mesOrigem, anoOrigem });
    return response.data;
  }
};

export default despesaService;
